// extracted by mini-css-extract-plugin
module.exports = {"seatingRoot":"SeatingChart_seatingRoot__1sRLj","seatPrice":"SeatingChart_seatPrice__2nftT"};